import { toJS } from 'mobx'
import initials from 'initials'
// import { Canvas } from 'canvas-prebuilt'

export function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1])
    else
        byteString = unescape(dataURI.split(',')[1])

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length)
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
    }

    return new Blob([ia], { type: mimeString })
}

export function checksum(jsonObj) {
    if (jsonObj === null) {
        return 0xdeadbeef
    } else {
        let s = JSON.stringify(jsonObj)
        var chk = 0x12345678
        var len = s.length
        for (var i = 0; i < len; i++) {
            chk += (s.charCodeAt(i) * (i + 1))
        }

        return (chk & 0xffffffff).toString(16)
    }
}

export function checkImageURL(imageURL) {
    let imgSrc = ""
    imageURL === "https://dev.pre.do/DefaultProfilePic.png" || imageURL === "https://tool.pre.do/DefaultProfilePic.png" ? (imgSrc = "") : (imgSrc = imageURL)
    return imgSrc
}

export function checkInitials(name) {
    let nameinitials = initials(name)
    var i = 0
    var character = ''
    while (i <= nameinitials.length) {

        character = nameinitials.charAt(i)
        if ((character !== character.toLowerCase()) && (character === character.toUpperCase())) {
            return 80
        }

        i++
    }
    return {}
}

export function generateUserAvatar(letters , size) {
        let canvas = document.createElement('canvas')
        // let canvas = new Canvas(60,60)
        let context = canvas.getContext("2d")
        let finalSize = size || 60
        let dataURI = null

        // Generate a random color every time function is called
        let color =  "#cccccc"

        // Set canvas with & height
        canvas.width = finalSize
        canvas.height = finalSize

        // Select a font family to support different language characters
        // like Arial
        context.font = Math.round(canvas.width / 2) + "px Arial"
        context.textAlign = "center"

        // Setup background and front color
        context.fillStyle = color
        context.fillRect(0, 0, canvas.width, canvas.height)
        context.fillStyle = "#707070"
        context.fillText(letters, finalSize / 2, finalSize / 1.5)

        // Set image representation in default format (png)
        dataURI = canvas.toDataURL()

        // Dispose canvas element
        canvas = null

        return dataURI

}

export function trimInitialsName(name) {
    return initials(name).substring(0, 2).toUpperCase()
}


export function getAvatarColors() {
    return ['#2ecc71', '#3498db', '#8e44ad', '#e67e22', '#e74c3c', '#1abc9c']
}

export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1)
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4()
}

//from: https://stackoverflow.com/questions/18082/validate-decimal-numbers-in-javascript-isnumeric
export function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
}

export function validateEmail(email) {
    //eslint-disable-next-line no-useless-escape
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
}

export function mangleEmail(email) {
    return email.replace(/@/g, "(AT)").replace(/\./g, "(DOT)")
}

export function compareByOrder(a, b) {
    if (a.order < b.order)
        return -1
    if (a.order > b.order)
        return 1
    return 0
}

export function compareByName(a, b) {
    if (a.hasOwnProperty('name') && b.hasOwnProperty('name')) {
        if (a.name.toLowerCase() < b.name.toLowerCase())
            return -1
        if (a.name.toLowerCase() > b.name.toLowerCase())
            return 1
    }
    return 0
}

export function toArray(input) {
    var arr = []
    if (Array.isArray(toJS(input))) {
        // console.log('isArray')
        arr = input
    } else {
        // console.log('isArray NOT')
        for (var key in input) {
            if (input.hasOwnProperty(key)) {
                var obj = input[key]
                if (obj) {
                    if (!obj['key'])
                        obj['key'] = key
                    arr.push(obj)
                }
            }
        }
    }
    return arr
}

//remove keys with empty values
export function cleanObj(my_object) {
    if (my_object) {
        let new_object = {}
        Object.keys(my_object).forEach(function (key) {
            if (typeof my_object[key] === 'object') {
                new_object[key] = cleanObj(my_object[key])
            } else if (typeof my_object[key] !== 'undefined' && my_object[key] != null) {
                new_object[key] = my_object[key]
            }
        })
        return new_object
    } else {
        return my_object //return the null of undefined
    }
}

export function calcRatingNum(eff, imp) {
    const effort = Math.min(eff, 2)
    const impact = Math.min(imp, 2)

    if (isNaN(impact) || impact === 0 || isNaN(effort) || effort === 0) {
        return 0
    }
    else if (impact === 2 && effort === 1) {
        return 4 //'DO'
    }
    else if (impact === 2 && effort === 2) {
        return 3 //'PROJECT'
    }
    else if (impact === 1 && effort === 1) {
        return 2 //'MAYBE'
    }
    else if (impact === 1 && effort === 2) {
        return 1 //'AVOID'
    }
    return -1
}

export function reverseRatingCalc(rating) {
    if (rating === 4) {
        return { impactRating: 2, effortRating: 1 } //'DO'
    }
    else if (rating === 3) {
        return { impactRating: 2, effortRating: 2 } //'PROJECT'
    }
    else if (rating === 2) {
        return { impactRating: 1, effortRating: 1 } //'MAYBE'
    }
    else if (rating === 1) {
        return { impactRating: 1, effortRating: 2 } //'AVOID'
    }
    else {
        return { impactRating: 0, effortRating: 0 } //'unrated'
    }
}

export function onImageError(e, name) {
    e.target.onerror = null
    e.target.src='https://ui-avatars.com/api/?name='+name+'&color=707070&background=cccccc&size=60'
}


// WEBPACK FOOTER //
// ./src/lib/HelperFunctions.js